var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38.92 34.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#277bfa;}.cls-1,.cls-2{stroke:#fff;stroke-miterlimit:10;}.cls-2{fill:none;stroke-width:1.66px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 19.46,
    cy: 17.28,
    r: 3.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.46,10.21c4.67,0,9,.67,12.27,1.79,3.94,1.36,6.36,3.41,6.36,5.27s-2.57,4.12-6.8,5.52c-3.2,1.06-7.4,1.61-11.83,1.61s-8.84-.52-12.08-1.62c-4.09-1.4-6.55-3.61-6.55-5.51s2.31-3.88,6.19-5.24c3.28-1.14,7.72-1.83,12.43-1.83h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.31,13.77c2.33-4.04,5.08-7.46,7.68-9.73,3.14-2.73,6.13-3.8,7.74-2.88,1.68,.97,2.29,4.28,1.39,8.65-.68,3.3-2.3,7.22-4.52,11.06-2.27,3.93-4.87,7.4-7.44,9.65-3.25,2.85-6.4,3.87-8.05,2.92-1.6-.92-2.21-3.94-1.44-7.98,.65-3.41,2.27-7.6,4.63-11.69h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.32,20.87c-2.34-4.04-3.93-8.13-4.59-11.52-.8-4.09-.23-7.21,1.38-8.14,1.68-.97,4.85,.16,8.18,3.11,2.52,2.24,5.11,5.6,7.32,9.43,2.28,3.93,3.98,7.91,4.64,11.26,.84,4.24,.16,7.48-1.49,8.43-1.6,.92-4.52-.05-7.64-2.74-2.63-2.27-5.45-5.77-7.81-9.85h0Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReact);
export default __webpack_public_path__ + "static/media/react.78530b9656b6cf153d2ea90010a66fa3.svg";
export { ForwardRef as ReactComponent };